<template>
    <v-row>
        <v-col cols="12" class="section-title">
            {{ $t('common.messages') }}
            <v-avatar v-if="!read && !loading" color="#85D6D6" size="20" class="float-right pointer" @click="showChat">
                <div style="color: #FFFFFF">!</div>
            </v-avatar>
        </v-col>
        <v-col cols="12">
            <loading-spinner v-if="loading" no-margin-top size="30" height="61"/>
            <v-row v-else class="chat-container pointer" align="center" @click="showChat">
                <v-col cols="3" lg="2">
                    <avatar-profile size="40" :img="clientImg"/>
                </v-col>
                <v-col cols="9" lg="10" class="pl-0">
                    <div class="chat-name text-truncate">
                        {{ clientName }}
                    </div>
                    <div class="chat-message text-truncate">
                        {{ message }}
                    </div>
                </v-col>
            </v-row>
        </v-col>

        <chat-dialog v-if="studentId" :clientId="studentId" ref="chat"></chat-dialog>
    </v-row>
</template>

<script>
import {db} from "@/utils/Firebase";
import ChatDialog from "@/components/student/ChatDialog";
import AvatarProfile from "@/components/elements/profile/AvatarProfile";
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    name: "RecentChatProfile",
    components: {LoadingSpinner, AvatarProfile, ChatDialog},
    props: {
        student: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            loading: false,
            lastMessage: null,
        }
    },
    computed: {
        studentId(vm = this) {
            return vm.student?.id || null
        },
        coachId(vm = this) {
            return vm.currentUser.uid || null
        },
        isMyLastMessage(vm = this) {
            return vm.lastMessage?.from === vm.coachId || false
        },
        read(vm = this) {
            if(vm.lastMessage && !vm.isMyLastMessage) return vm.lastMessage?.read
            return true
        },
        clientImg(vm = this) {
            return vm.isMyLastMessage ?
                vm.account?.avatar || vm.imgPlaceholder :
                vm.student?.avatar || vm.imgPlaceholder
        },
        clientName(vm = this) {
            return vm.isMyLastMessage ? vm.account?.name : vm.student?.name
        },
        message(vm = this) {
            return vm.lastMessage?.message || ''
        }
    },
    async mounted() {
        const vm = this
        await vm.loadLastMessage()
    },
    methods: {
        showChat(){
            const vm = this
            vm.$refs.chat.show()
        },
        async loadLastMessage() {
            const vm = this
            if (!vm.coachId || !vm.studentId) return
            vm.loading = true
            let chatRef = await db.collection('privateChats')
                .where('type', '==', 'coach_student')
                .where('participants', 'in', [[vm.coachId, vm.studentId]])
                .get()
            vm.lastMessage = chatRef.docs[0]?.data()?.lastMessage || null
            vm.loading = false
        },
    },
    watch: {
        account() {
            this.loadLastMessage()
        }
    }
}
</script>

<style scoped>

.section-title {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
}

.chat-container {
    background: #85D6D6;
    border-radius: 17px;
}

.chat-name {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
}

.chat-message {
    font-weight: 300;
    font-size: 13px;
    line-height: 16px;
    color: #333333;
    margin-top: 4px;
}

</style>